import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import { connect } from "react-redux";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { alertActions, commonActions } from "../../_actions";
import { EmptyRecord } from "../../utils/PageUtility";
import { commonService } from "../../_services";
import { appConstants } from "../../_constants";
import CircularProgress from '../../utils/CircularProgress';
import DataEntryPanel from "./DataEntryPanel"
import MyDataEntryTable from "./MyDataEntryTable";
import AllDataEntryTable from "./AllDataEntryTable";
import Tabs from "components/CustomTabs/CustomTabs.jsx";
import EditDataEntry from "./EditDataEntry"
import ViewMore from "./ViewMore"

import ReconciliationIcon from "@material-ui/icons/RestorePage";
import { appHelpers } from "../../_helpers";
import AddRecordModal from "./AddRecordModal";

const statusTypes = [
    { name: "All Status", value: "-1" },
    { name: "Pending", value: 0 },
    { name: "Approved", value: 1 },
    { name: "Rejected", value: 2 }
];

const today = new Date();
let aMonthAgo = new Date();
aMonthAgo.setDate(today.getDate() - 30);


class DataEntry extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            airlines: [],
            users: [],
            name: '',
            airlineName: '',
            myDataEntryData: [],
            AirlineId: '-1',
            addAirlineId: '-1',
            Type: '',
            Status: '-1',
            startDate: aMonthAgo,
            endDate: today,
            status: '',
            isProgressActive: true,
            currentPage: 1,
            pageSize: 10,
            totalPaymentCount: 0,
            requestingDataEntry: true,
            isOpen: false,
            isEditModalOpen: false,
            error: false,
            formError: '',
            passengerCount: '',
            newAirlineId: '-1',
            pendingDataEntryId: '',
            dataEntryId: '',
            isCommentModalOpen: false,
            comment: '',
            addComment: '',
            processName: '',
            airlineError: false,
            flightNumbers: [],
            FlightNumber: '-1',
            locationData: [],
            locationId: '-1',
            destinationData: [],
            destinationId: '-1',
            searchFlightNumber: '-1',
            searchLocationId: '-1',
            billablePaxCount: '',
            newFlightNumber: '-1',
            newFlightDate: new Date(),
            newLocationId: '-1',
            newDestinationId: '-1',
            flightError: false,
            locationError: false,
            passengerCountError: false,
            destinationError: false,
            billablePaxError: false,
            addingDataEntry: true,
            flightDate: new Date(),
            searchDestinationId: '-1',
            dataEntryData: [],
            newPassengerCount: '',
            newBillablePaxCount: '',
            user: "",
            isViewMoreOpen: false,
            getMoreData: [],
            myTotalCount: 0,
            totalCount: 0,
            searchFlightNumbers: [],
            editFlightNumbers: [],
            disabledOption: { value: "-1", label: "Name" },
            fileName: null,
            file: null,
            filePath: null
        };
    }


    componentDidMount() {
        const { airports, user, dispatch, airlines, users } = this.props;
        const { startDate, endDate, pageSize } = this.state;
        if (airports) {
            this.setState({ destinationData: airports, locationData: airports })
        } else {
            dispatch(commonActions.getAllAirports())
        }

        if (airlines) {
            this.setState({ airlineData: airlines })
        } else {
            dispatch(commonActions.getAllAirlines())
        }

        if (users) {
            this.setState({ users: users.ResultList })
        } else {
            dispatch(commonActions.getAllUsers())
        }

        if (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) {
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location };
            this.setState({ searchLocationId: userLocation, locationId: userLocation })
            // this.setState({ searchLocationId: user.AirportCode, locationId: user.AirportCode })
            let payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: 1,
                Size: pageSize,
                CreatedBy: user.userId,
                DepartureLocation: user.AirportCode,

            };
            let allDataPayload = {
                StartDate: startDate,
                EndDate: endDate,
                From: 1,
                Size: pageSize,

            };
            this.searchMyDataEntry(1, payload);
            this.searchDataEntry(1, allDataPayload);

        } else if (user.Location) {  //Check if location is mapped to user. That means its an outstation user
            let userObj = { ...user };
            let userLocation = { value: userObj.AirportCode, label: userObj.Location }
            this.setState({ searchLocationId: userLocation, locationId: userLocation })
            // this.setState({ searchLocationId: user.AirportCode, locationId: user.AirportCode })
            let payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: 1,
                Size: pageSize,
                CreatedBy: user.userId,
                DepartureLocation: user.AirportCode,

            };
            let allDataPayload = {
                StartDate: startDate,
                EndDate: endDate,
                From: 1,
                Size: pageSize,

            };
            this.searchMyDataEntry(1, payload);
            this.searchDataEntry(1, allDataPayload);
        }
        else {
            this.loadDataEntryData();
        }
    }



    componentWillReceiveProps = function (nextProps) {
        const { airlines, users, user, airports } = nextProps;
        if (airlines) {
            let modifiedAirline = [...airlines];
            let allAirlines = { Airline: "All Airlines", AirlineId: "-1" };
            modifiedAirline.unshift(allAirlines);
            this.setState({ airlines: modifiedAirline });

        }
        if (users) {
            this.setState({ users: users.ResultList });
        }
        if (user) {
            this.setState({ user: user.userId });
        }
        if (airports) {
            let modifiedAirport = [...airports];
            modifiedAirport.unshift({ Name: "All Airports", airportLocation: "-1" });
            this.setState({ destinationData: modifiedAirport, locationData: modifiedAirport })
        }
    };

    loadDataEntryData = () => {
        this.searchDataEntry();
        this.searchMyDataEntry();
    }

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    // method: display name of airlineId
    filterAirlines = (airlineId) => {
        const { airlines } = this.state;
        let airlineName = airlines.find(u => u.AirlineId === airlineId);
        if (airlineName) {
            return `${airlineName.Airline}`
        } else {
            return 'Unknown Airline'
        }
    }

    // method: display name of userId
    filterUsers = (userId) => {
        const { users } = this.state;

        if (users) {
            if (userId === null) {
                return ""
            } else {
                let userName = users.find(u => u.Id === userId);
                if (userName) {
                    return `${userName.FirstName} ${userName.LastName}`
                } else {
                    return 'Unknown User'
                }
            }
        }
    }

    // display name of statusId
    filterStatus = (statusId) => {
        let status = statusTypes.find(item => item.value === statusId)
        if (status) {
            return `${status.name}`
        } else {
            return 'Unknown Status'
        }
    };

    //Get flight Numbers on select of airline by passing the airlineId
    fetchAirlineFlightNumbers = (airlineId, stateValue) => {
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.getAirlinesFlightNumbers(airlineId)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let modifiedFlights = [...response.Results];
                    modifiedFlights.unshift({ FlightNumber: "All Flights" });
                    // this.setState({ flightNumbers: response.Results , searchFlightNumbers: response.Results});
                    this.setState({ [stateValue]: modifiedFlights });
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            });
    };

    // approve a dataEntry
    approveDataEntry = () => {

        const { user, dispatch } = this.props
        let userId = user.userId
        const payload = {
            Id: this.state.dataEntryId,
            ProcessedBy: userId,
            Status: 1,
            Comment: this.state.comment
        }

        dispatch(alertActions.startRequest());

        commonService.processDataEntry(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify("Approved Successfully"));
                    this.closeCommentModal()
                    this.searchDataEntry()
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                }
            })
    }

    // decline a dataEntry
    declineDataEntry = () => {

        const { user, dispatch } = this.props
        let userId = user.userId
        const payload = {
            Id: this.state.dataEntryId,
            ProcessedBy: userId,
            Status: 2,
            Comment: this.state.comment
        }

        // console.log('decline data payload', payload)

        dispatch(alertActions.startRequest());

        commonService.processDataEntry(payload)
            .then((res) => {
                // console.log('decline data res', res)
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify("Declined Successfully"));
                    this.closeCommentModal();
                    this.searchDataEntry()

                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    dispatch(alertActions.stopRequest());
                }

            })
    };

    selectChange = event => {
        this.setState({ [event.target.name]: event.target.value });

        if (event.target.name === 'addAirlineId') {
            // console.log('event.target.name', event.target.name)
            // this.setState({flightNumbers: []});

            this.fetchAirlineFlightNumbers(event.target.value, 'flightNumbers');
        }
        if (event.target.name === 'newAirlineId') {
            this.fetchAirlineFlightNumbers(event.target.value, 'editFlightNumbers');
        }
        if (event.target.name === "AirlineId") {
            this.fetchAirlineFlightNumbers(event.target.value, 'searchFlightNumbers')
        }

    };

    handleReactSelectChange = (value, name) => {
        this.setState({ [name.name]: value })
        if (value.value === undefined || value.value === "-1" || value.value === "All Flights") {
            this.setState({ [name.name]: "-1" })
        }
        if (name.name === 'addAirlineId') {
            this.fetchAirlineFlightNumbers(value.value, 'flightNumbers');
        }
        if (name.name === 'newAirlineId') {
            this.fetchAirlineFlightNumbers(value.value, 'editFlightNumbers');
        }
        if (name.name === "AirlineId") {
            this.fetchAirlineFlightNumbers(value.value, 'searchFlightNumbers')
        }
    };

    //search dataEntry with parameters
    searchDataEntry = (pageNumber = 1, payload) => {
        let { AirlineId, pageSize, startDate, endDate, searchLocationId, searchDestinationId, searchFlightNumber, Status } = this.state;
        const { dispatch } = this.props;
        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");
        // let searchValue = searchLocationId.value;

        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                // AirlineId: AirlineId,
                // FlightNo: searchFlightNumber,
                // DepartureLocation: searchLocationId,
                // DestinationLocation: searchDestinationId,
                // User: user.userId

            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (searchFlightNumber !== "-1" && searchFlightNumber !== "All Flights") {
                payload.FlightNo = searchFlightNumber.value
            }
            if (searchLocationId !== "-1") {
                payload.DepartureLocation = searchLocationId.value
            }
            if (searchDestinationId !== "-1") {
                payload.DestinationLocation = searchDestinationId.value
            }
            if (Status !== "-1") {
                payload.Status = Status.value
            }
            //
            // if (Status !== "-1") {
            //     payload.Status = Status.value.value
            // }
            // } else if (Status !== "-1") {
            //     window.alert('hey')
            //     // payload.Status = Status.value.value
            // }
        }
        dispatch(alertActions.startRequest());
        commonService.getDataEntry(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                // console.log('search all data entry', response);
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber,
                        totalCount: response.TotalCount,
                        dataEntryData: response.ResultList,
                        requestingDataEntry: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingDataEntry: false });
                }
            })
    };

    //search user-created dataEntry with parameters
    searchMyDataEntry = (pageNumber = 1, payload) => {
        let { AirlineId, pageSize, startDate, endDate, Status, searchLocationId,
            searchDestinationId, searchFlightNumber, } = this.state;
        const { dispatch, user } = this.props;

        startDate = appHelpers.formatDateSpecific(startDate, "YYYY-MM-DD");
        endDate = appHelpers.formatDateSpecific(endDate, "YYYY-MM-DD");

        if (!payload) {
            payload = {
                StartDate: startDate,
                EndDate: endDate,
                From: pageNumber,
                Size: pageSize,
                CreatedBy: user.userId,
                // Status: status
                // FlightNo: searchFlightNumber,
                // DepartureLocation: searchLocationId,
                // DestinationLocation: searchDestinationId,
            };

            if (AirlineId !== "-1") {
                payload.AirlineId = AirlineId.value
            }
            if (searchFlightNumber !== "-1" && searchFlightNumber !== "All Flights") {
                payload.FlightNo = searchFlightNumber.value
            }
            if (searchLocationId !== "-1") {
                payload.DepartureLocation = searchLocationId.value
            }
            if (searchDestinationId !== "-1") {
                payload.DestinationLocation = searchDestinationId.value
            }
            if (Status !== "-1") {
                payload.Status = Status.value
            }

            // if (Status !== "-1") {
            //     payload.Status = Status.value.value
            // }
        }

        // console.log(' search reconciliation payload', payload);

        dispatch(alertActions.startRequest());
        commonService.getDataEntry(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        myCurrentPage: pageNumber,
                        myTotalCount: response.TotalCount,
                        myDataEntryData: response.ResultList,
                        requestingDataEntry: false
                    })
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({ requestingDataEntry: false });
                }
            })
        this.setState({ flightNumbers: [] })
    };

    //open add data entry modal
    handleOpenModal = () => {
        this.setState({ isOpen: true, error: false })
    };

    // close add data entry modal
    handleCloseModal = () => {
        this.setState({
            isOpen: false,
            airlineError: false,
            locationError: false,
            destinationError: false,
            passengerCountError: false,
            flightNumberError: false,
            billablePaxError: false,
            billablePaxError2: false

        });
        this.resetForm()
    };

    //open edit data entry Modal
    openEditModal = (item) => {
        this.setState({ isEditModalOpen: true })
        this.setState({
            newAirlineId: item.AirlineId,
            newFlightNumber: item.FlightNo,
            newFlightDate: item.DepartureDate,
            newPassengerCount: item.PassengerCount,
            newBillablePaxCount: item.BillablePassenger,
            newLocationId: item.DepartureLocationCode,
            newDestinationId: item.DestinationLocationCode,
            pendingDataEntryId: item.Id,
            filePath: item.FilePath
        });

        if (item.AirlineId) {
            // console.log('item', item.AirlineId);
            this.setState({ flightNumbers: [] });
            this.fetchAirlineFlightNumbers(item.AirlineId, 'editFlightNumbers');
        }
        this.setState({ flightNumbers: [] });

    };

    // close edit data entry modal
    closeEditModal = () => {
        this.setState({
            isEditModalOpen: false,
            airlineError: false,
            error: false,
            flightError: false,
            locationError: false,
            destinationError: false,
            passengerCountError: false,
            billablePaxError: false,
            searchFlightNumbers: [],
            flightNumbers: [],
            billablePaxError2: false,
            file: null,
            fileName: ''
            //toggle other errors
            // typeError: false
        });
    };

    // open comment modal
    openCommentModal = (dataEntryId, action) => {
        this.setState({
            dataEntryId,
            isCommentModalOpen: true,
            processName: action
        })
    }

    // close comment modal
    closeCommentModal = () => {
        this.setState({
            isCommentModalOpen: false,
            dataEntryId: "",
            comment: ""
        })
    };

    closeViewMoreModal = () => {
        this.setState({
            isViewMoreOpen: false,
            dataEntryId: ""
        })
    }

    openViewMoreModal = (item) => {
        // console.log('item', item)
        this.setState({
            // dataEntryId,
            isViewMoreOpen: true,
            getMoreData: item

        })
    };


    // update reconciliation
    handleUpdate = (dataEntryId) => {
        //   console.log('dataEntryId', dataEntryId)
        const { newAirlineId, newFlightNumber, newFlightDate, newPassengerCount, newBillablePaxCount,
            newDestinationId, newLocationId, file } = this.state
        const { user, dispatch } = this.props
        let departureDate = appHelpers.formatDateSpecific(newFlightDate, "YYYY-MM-DD");

        // console.log('newBillablePax', newBillablePaxCount);

        if (newAirlineId === "" || newAirlineId === "Placeholder") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (newFlightNumber === "" || newFlightNumber === "-1") {
            this.setState({ flightError: true })
        } else {
            this.setState({ flightError: false })
        }

        if (newLocationId === "" || newLocationId === "-1") {
            this.setState({ locationError: true })
        } else {
            this.setState({ locationError: false })
        }

        if (newDestinationId === "" || newDestinationId === "-1") {
            this.setState({ destinationError: true })
        } else {
            this.setState({ destinationError: false })
        }

        if (newPassengerCount === "") {
            this.setState({ passengerCountError: true })
        } else {
            this.setState({ passengerCountError: false })
        }

        if (newBillablePaxCount === "") {
            this.setState({ billablePaxError: true })
        } else {
            this.setState({ billablePaxError: false })
        }

        if (newBillablePaxCount > newPassengerCount) {
            this.setState({ billablePaxError2: true });
        }

        if (newAirlineId === "" || newAirlineId === "Placeholder" || newFlightNumber === "" || newFlightNumber === "-1" ||
            newPassengerCount === "" || newBillablePaxCount === "") {
            return
        }

        // payload in form data format
        let payload = new FormData();
        payload.append('Id', dataEntryId);
        payload.append('AirlineId', newAirlineId);
        payload.append('FlightNo', newFlightNumber);
        payload.append('DepartureDate', departureDate);
        payload.append('DepartureLocation', newLocationId);
        payload.append('DestinationLocation', newDestinationId);
        payload.append('BillablePassenger', newBillablePaxCount);
        payload.append('PassengerCount', newPassengerCount);
        payload.append('CreatedBy', user.userId);
        // payload.append('Comments', addComment);
        if (file !== null) {
            payload.append('file', file);
        }

        // const payload = {
        //     Id: dataEntryId,
        //     AirlineId: newAirlineId,
        //     FlightNo: newFlightNumber,
        //     DepartureDate: departureDate,
        //     DepartureLocation: newLocationId,
        //     DestinationLocation: newDestinationId,
        //     BillablePassenger: newBillablePaxCount,
        //     PassengerCount: newPassengerCount,
        //     CreatedBy: user.userId
        // };

        // console.log('update payload ', payload);
        dispatch(alertActions.startRequest());

        commonService.saveDataEntry(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {

                    dispatch(alertActions.notify("Update Successful"));
                    this.closeEditModal();
                    this.searchMyDataEntry();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        requestingDataEntry: false
                    });
                }
            })
    }

    // add new reconciliation
    handleSubmit = () => {

        let { addAirlineId, FlightNumber, flightDate,
            locationId, passengerCount, destinationId, billablePaxCount,
            addComment, file
        } = this.state

        flightDate = appHelpers.formatDateSpecific(flightDate, "YYYY-MM-DD");

        const { user, dispatch } = this.props

        if (addAirlineId === "" || addAirlineId === "-1") {
            this.setState({ airlineError: true })
        } else {
            this.setState({ airlineError: false })
        }

        if (FlightNumber === "" || FlightNumber === "-1") {
            this.setState({ flightError: true })
        } else {
            this.setState({ flightError: false })
        }

        if (locationId === "" || locationId === "-1") {
            this.setState({ locationError: true })
        } else {
            this.setState({ locationError: false })
        }

        if (passengerCount === "") {
            this.setState({ passengerCountError: true })
        } else {
            this.setState({ passengerCountError: false })
        }

        if (destinationId === "" || destinationId === "-1") {
            this.setState({ destinationError: true })
        } else {
            this.setState({ destinationError: false })
        }

        if (billablePaxCount === "") {
            this.setState({ billablePaxError: true })
        } else {
            this.setState({ billablePaxError: false })
        }

        if (billablePaxCount > passengerCount) {
            this.setState({ billablePaxError2: true });
        }

        if (addAirlineId === "" || addAirlineId === "Placeholder" || FlightNumber === "" || FlightNumber === "-1" ||
            locationId === "" || locationId === "-1" || passengerCount === "" ||
            destinationId === "" || destinationId === "-1" || billablePaxCount === "") {
            return
        }

        // payload in form data format
        let payload = new FormData();
        payload.append('AirlineId', addAirlineId.value);
        payload.append('FlightNo', FlightNumber.value);
        payload.append('DepartureDate', flightDate);
        payload.append('DepartureLocation', locationId.value);
        payload.append('PassengerCount', passengerCount);
        payload.append('DestinationLocation', destinationId.value);
        payload.append('BillablePassenger', billablePaxCount);
        payload.append('CreatedBy', user.userId);
        payload.append('Comments', addComment);
        if (file !== null) {
            payload.append('file', file);
        }

        // const payload = {
        //     AirlineId: addAirlineId.value,
        //     FlightNo: FlightNumber.value,
        //     DepartureDate: flightDate,
        //     DepartureLocation: locationId.value,
        //     PassengerCount: passengerCount,
        //     DestinationLocation: destinationId.value,
        //     BillablePassenger: billablePaxCount,
        //     CreatedBy: user.userId,
        //     Comments: addComment
        // }
        // console.log('payload', payload)
        dispatch(alertActions.startRequest());

        commonService.saveDataEntry(payload)
            .then((res) => {
                // console.log('res', res);
                dispatch(alertActions.stopRequest());
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    dispatch(alertActions.notify('Data Added Successfully'));
                    this.handleCloseModal();
                    this.searchMyDataEntry();
                    this.resetForm();
                }
                else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(alertActions.error(res.response));
                    this.setState({
                        formError: res.response,
                        error: true,
                        addingDataEntry: false
                    });
                }
            })
    }

    resetForm = () => {
        const { locationId } = this.state;
        const { user } = this.props;
        const locationId_ = (user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? locationId : "";
        this.setState({
            addAirlineId: "", newAirlineId: "", passengerCount: "",
            locationId: locationId_, FlightNumber: "", destinationId: "",
            billablePaxCount: "", file: null, fileName: ''
        })
    };

    onDrop = (files) => {
        this.setState({ fileName: files[0].name, file: files[0] });
    }

    render() {
        const { airlines, AirlineId, airlineName,
            startDate, endDate, currentPage, pageSize, totalCount,
            requestingDataEntry, Status, isOpen, isEditModalOpen,
            passengerCount, newAirlineId, pendingDataEntryId, isCommentModalOpen, comment, processName,
            formError, error, myDataEntryData, myCurrentPage, billablePaxError2,
            airlineError, myTotalCount, flightNumbers, FlightNumber, locationData,
            locationId, destinationData, destinationId, searchFlightNumber,
            searchLocationId, searchDestinationId, billablePaxCount, flightDate,
            dataEntryData, newFlightNumber, newDestinationId, newFlightDate,
            newLocationId, newPassengerCount, newBillablePaxCount, flightError, locationError,
            destinationError, passengerCountError, billablePaxError, user, isViewMoreOpen,
            getMoreData, searchFlightNumbers, editFlightNumbers, addAirlineId, disabledOption,
            fileName, filePath } = this.state;

        const { requesting } = this.props;

        if (requestingDataEntry)
            return (
                <CircularProgress />
            );
        return (
            <div>
                <AddRecordModal
                    user={this.props.user}
                    selectReactSelectChange={this.handleReactSelectChange}
                    selectChange={this.selectChange}
                    isOpen={isOpen}
                    data={airlines}
                    handleOpenModal={this.handleOpenModal}
                    handleSubmit={this.handleSubmit}
                    handleClose={this.handleCloseModal}
                    flightNumbers={flightNumbers}
                    FlightNumber={FlightNumber.value}
                    locationData={locationData}
                    locationId={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? locationId : locationId.value}
                    destinationData={destinationData}
                    destinationId={destinationId.value}
                    passengerCount={passengerCount}
                    addAirlineId={addAirlineId.value}
                    formError={formError}
                    airlineError={airlineError}
                    error={error}
                    flightError={flightError}
                    locationError={locationError}
                    destinationError={destinationError}
                    passengerCountError={passengerCountError}
                    billablePaxError={billablePaxError}
                    handleDateChange={this.handleDateChange}
                    flightDate={flightDate}
                    billablePaxError2={billablePaxError2}
                    requesting={requesting}
                    onDrop={this.onDrop}
                    fileName={fileName}

                />
                <DataEntryPanel
                    user={this.props.user}
                    airline={airlineName}
                    AirlineId={AirlineId.value}
                    Status={Status.value}
                    selectAirlineChange={this.selectChange}
                    selectChange={this.handleReactSelectChange}
                    airlineData={airlines}
                    onSearch={this.loadDataEntryData}
                    startDate={startDate}
                    endDate={endDate}
                    handleDateChange={this.handleDateChange}
                    statusTypes={statusTypes}
                    searchFlightNumbers={searchFlightNumbers}
                    searchLocationData={locationData}
                    searchDestinationData={destinationData}
                    searchFlightNumber={searchFlightNumber}
                    searchLocationId={(this.props.user.AppRole === appConstants.ROLES.AIRPORT_MANAGER) || (user.Location) ? searchLocationId : searchLocationId.value}
                    searchDestinationId={searchDestinationId.value}
                    billablePaxCount={billablePaxCount}
                    disabledOption={disabledOption}
                />
                <ViewMore
                    isViewMoreOpen={isViewMoreOpen}
                    closeViewMore={this.closeViewMoreModal}
                    moreData={getMoreData}
                    filterStatus={this.filterStatus}
                    filterUsers={this.filterUsers}
                />

                <GridContainer>
                    <EditDataEntry
                        user={this.props.user}
                        formError={formError}
                        error={error}
                        airlineError={airlineError}
                        flightError={flightError}
                        locationError={locationError}
                        destinationError={destinationError}
                        passengerCountError={passengerCountError}
                        billablePaxError={billablePaxError}
                        handleDateChange={this.handleDateChange}
                        closeEditModal={this.closeEditModal}
                        isEditModalOpen={isEditModalOpen}
                        handleUpdate={this.handleUpdate}
                        newAirlineId={newAirlineId}
                        flightNumbers={editFlightNumbers}
                        newFlightNumber={newFlightNumber}
                        newLocationId={newLocationId}
                        newDestinationId={newDestinationId}
                        locationData={locationData}
                        destinationData={destinationData}
                        newPassengerCount={newPassengerCount}
                        newBillablePaxCount={newBillablePaxCount}
                        pendingDataEntryId={pendingDataEntryId}
                        airlines={airlines}
                        newFlightDate={newFlightDate}
                        selectChange={this.selectChange}
                        billablePaxError2={billablePaxError2}
                        disabled={requesting}
                        onDrop={this.onDrop}
                        fileName={fileName}
                        filePath={filePath}
                    />
                    <Tabs
                        headerColor="success"
                        tabs={[
                            {
                                tabName: " My Data Entry",
                                tabIcon: ReconciliationIcon,
                                tabContent: (
                                    <GridItem xs={12} sm={12} md={12}>
                                        {
                                            !requestingDataEntry && myTotalCount !== 0
                                            &&
                                            <MyDataEntryTable
                                                myDataEntryData={myDataEntryData}
                                                currentPage={myCurrentPage}
                                                pageSize={pageSize}
                                                fetchDataEntry={this.searchMyDataEntry}
                                                totalCount={myTotalCount}
                                                filterAirlines={this.filterAirlines}
                                                filterStatus={this.filterStatus}
                                                openEditModal={this.openEditModal}
                                                openViewMore={this.openViewMoreModal}

                                            />}

                                        {
                                            !requestingDataEntry && myTotalCount === 0
                                            && <EmptyRecord message={'No Data Entry Record'} />
                                        }
                                    </GridItem>

                                )
                            },
                            {
                                tabName: "All Data Entry",
                                tabIcon: ReconciliationIcon,
                                tabContent: (
                                    <GridItem xs={12} sm={12} md={12}>
                                        {
                                            !requestingDataEntry && totalCount !== 0
                                            &&
                                            <AllDataEntryTable
                                                user={user}
                                                formError={formError}
                                                error={error}
                                                dataEntryData={dataEntryData}
                                                currentPage={currentPage}
                                                pageSize={pageSize}
                                                fetchDataEntry={this.searchDataEntry}
                                                totalCount={totalCount}
                                                filterAirlines={this.filterAirlines}
                                                filterUsers={this.filterUsers}
                                                filterStatus={this.filterStatus}
                                                approveDataEntry={this.approveDataEntry}
                                                declineDataEntry={this.declineDataEntry}
                                                handleUpdate={this.handleUpdate}
                                                newAirlineId={newAirlineId}
                                                pendingDataEntryId={pendingDataEntryId}
                                                airlines={airlines}
                                                isCommentModalOpen={isCommentModalOpen}
                                                isViewMoreOpen={isViewMoreOpen}
                                                openCommentModal={this.openCommentModal}
                                                openViewMore={this.openViewMoreModal}
                                                closeCommentModal={this.closeCommentModal}
                                                comment={comment}
                                                processName={processName}
                                                selectChange={this.selectChange}
                                            />
                                        }

                                        {
                                            !requestingDataEntry && totalCount === 0
                                            && <EmptyRecord message={'No Data Entry Record'} />
                                        }
                                    </GridItem>
                                )
                            }
                        ]}
                    />
                </GridContainer>


            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { modal, alert, airlines, reconciliation, user,
        users, requesting, airports } = state;
    return {
        modal,
        alert,
        airlines,
        reconciliation,
        user,
        users,
        requesting,
        airports
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(DataEntry)));



// WEBPACK FOOTER //
// ./src/views/DataEntry/Index.jsx